import { SelectFields } from '@repo/toolkit/types'

import { Guide } from '../../lib/types/models/guide/guide'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentGuide<T extends FieldsSelector<Guide>>(id: number, fields: T) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.enrollments.getEnrollmentGuide.url, { id }), {
        fields
      })
    )
    .get<SelectFields<Guide, T>>()
}
